// =========================================================
// frontend/js/stats.js - V11.8 (CSRD Robust & Multi-Year)
// =========================================================
window.DEFAULT_CO2_FACTORS = {
    car: 0.20,
    public: 0.10,
    electro: 0.10,
    bike: 0.0,
    ho_electricity: 0.35,
    ho_heating: 1.15
};
window.FUEL_PRICES = {
    gasoline: 1.85,
    electricity: 0.42,
    defaults: {
        car_consumption: 7.5,
        electro_consumption: 20.0
    }
};
window.calculateImpact = function(commuteData, daysCount, eventSnapshotCO2) {
    // 1. Sicherstellen, dass daysCount eine Zahl ist
    var days = daysCount || 1;
    // 2. Fallback für fehlende Daten
    if (!commuteData) return {
        co2Netto: 0,
        money: 0,
        time: 0,
        trees: 0
    };
    // 3. Zahlen-Konverter (Heilt Kommas und Strings)
    var toNum = function(val) {
        if (!val) return 0;
        var s = String(val).replace(',', '.');
        var n = parseFloat(s);
        return isNaN(n) ? 0 : n;
    };
    // 4. Basis-Werte
    var d = toNum(commuteData.distance);
    var t = toNum(commuteData.time);
    var c = toNum(commuteData.consumption);
    var type = commuteData.type || 'car';
    var totalKm = d * 2 * days;
    // 5. Geld & Zeit (Wird IMMER berechnet)
    var mSaved = 0;
    if (type === 'car') {
        var cons = c || 7.5;
        mSaved = totalKm / 100 * cons * 1.85;
    } else if (type === 'electro') {
        var cons = c || 20.0;
        mSaved = totalKm / 100 * cons * 0.42;
    }
    if (commuteData.isCarpool) mSaved = mSaved / 2;
    var tSaved = t * 2 * days / 60;
    // 6. CO2 (Snapshot oder Live)
    var co2Netto = 0;
    var snap = toNum(eventSnapshotCO2);
    if (eventSnapshotCO2 !== null && eventSnapshotCO2 !== undefined && snap > 0) co2Netto = snap * days;
    else {
        var transportFactor = type === 'car' ? 0.20 : 0.10;
        if (toNum(commuteData.customEmissions) > 0) transportFactor = toNum(commuteData.customEmissions) / 1000;
        if (commuteData.isCarpool) transportFactor = transportFactor / 2;
        var brutto = totalKm * transportFactor;
        var isWinter = new Date().getMonth() <= 3 || new Date().getMonth() >= 9;
        var leak = 0.35 + (isWinter ? 1.15 : 0);
        co2Netto = Math.max(0, brutto - leak * days);
    }
    // WICHTIG: Vier Felder müssen zurückkommen!
    return {
        co2Netto: co2Netto,
        money: mSaved,
        time: tSaved,
        trees: co2Netto / 12.5,
        version: "11.8" // Marker zur Kontrolle
    };
};
// NEU: Berechnet die Statistiken für alle verfügbaren Jahre
window.calculateAllYearsStats = function(userId) {
    var u = window.currentUser;
    var targetUid = userId || (u ? u.uid : null);
    if (!targetUid || !u || !u.commute) return {};
    var events = window.events || [];
    var statsByYear = {};
    for(var i = 0; i < events.length; i++){
        var e = events[i];
        var type = (e.type || "").toUpperCase();
        var isHO = type === 'HO' || type === 'HOMEOFFICE';
        if (e.userId === targetUid && isHO && e.status === 'APPROVED') {
            var year = e.date.substring(0, 4);
            if (!statsByYear[year]) statsByYear[year] = {
                totalCO2: 0,
                totalMoney: 0,
                totalTime: 0,
                approvedCount: 0
            };
            var impact = window.calculateImpact(u.commute, 1, e.co2SavedAtBooking);
            statsByYear[year].totalCO2 += impact.co2Netto || 0;
            statsByYear[year].totalMoney += impact.money || 0;
            statsByYear[year].totalTime += impact.time || 0;
            statsByYear[year].approvedCount++;
        }
    }
    var formattedStats = {};
    for(var y in statsByYear)if (statsByYear[y].approvedCount > 0) formattedStats[y] = {
        hoDays: statsByYear[y].approvedCount,
        savedTimeHours: Math.round(statsByYear[y].totalTime),
        savedMoney: statsByYear[y].totalMoney.toFixed(2),
        savedCo2: statsByYear[y].totalCO2.toFixed(1),
        trees: (statsByYear[y].totalCO2 / 12.5).toFixed(1)
    };
    return formattedStats;
};

//# sourceMappingURL=frontend.39820023.js.map
